import React from 'react';

type Listener = () => void;

const EMPTY_SNAPSHOT: readonly string[] = [];
const openIds = new Set<string>();
const listeners = new Set<Listener>();
let snapshot: string[] = [];

const emit = () => {
  snapshot = Array.from(openIds);
  listeners.forEach((listener) => listener());
};

export const registerOpenModal = (id: string) => {
  if (openIds.has(id)) return;
  openIds.add(id);
  emit();
};

export const unregisterOpenModal = (id: string) => {
  if (!openIds.delete(id)) return;
  emit();
};

const subscribe = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => snapshot;

const getServerSnapshot = () => EMPTY_SNAPSHOT as string[];

/**
 * Returns the ids of all CDS modals (including `Dialog` and `FullscreenDialog`)
 * that are currently open, in the order they were opened.
 *
 * The list updates as modals open and close. Each id is the `id` prop passed to
 * the modal, or the auto-generated id if none was provided.
 */
export const useCdsModals = () => {
  const openModals = React.useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot
  );

  return { openModals };
};
